<div [class]="className">{{ text }}</div>
